export const news = {
  newsPageTitle: "Promosies en nuus",
  newsPageSubtitle: "Jongste promosies, toernooie en opdaterings",
  newsNew: "Nuut",
  newsReadMore: "Lees meer",
  newsLoadMore: "Wys meer nuus",
  articleBadgePromo: "Promosie",
  articleNotFound: "Artikel nie gevind nie",
  articleBackToNews: "Terug na nuus",
  articleCtaTitle: "Gereed om te speel?",
  articleCtaSubtitle: "Maak gebruik van hierdie promosie en begin nou wen",
  articleCtaPlay: "Speel nou",
  articleCtaMore: "Bekyk meer promosies",
  articleRelated: "Meer nuus",
  articleViewAll: "Sien alles",
};
